import Vue from "vue";
import Vuex from "vuex";
import lodash from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);

Vue.use(Vuex);

import commons from "../commons/commons"
import LocalStorageService from "./LocalStorageService";
import { authorizationStore } from "./authorizationStore";
import { commonStore } from "./commonStore";
import moduleGuard from "../commons/moduleGuard";

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export const store = new Vuex.Store({
    state: {
        ...commonStore.state,
        modules: {},
        users: [],
        states: [],
        selection: { type: '', item: null },
        baseServer: null,
        vector: null,
        originalVector: null,
        workspace: null,
        vectorId: null,
        list: null,
        filterText: '',
        filterKeyword: null,
        suggestions: [],
        canvas: {
            information: [],
            states: [],
            flows: [],
            activities: [],
            menus: [],
            actions: [],
            documents: [],
            designer: {},
        },
        beta: (authorizationStore.state.roles || []).some(x => x === 'Administrator' || x === 'Consultant')
    },
    mutations: {
        setCanvas(state, data) {
            state.canvas = data;
        },
        setVector(state, data) {
            state.vectorId = data;
        },
        commitVector(state, data) {
            state.vector = data;
            if (state.vector && !state.vector.ownerWorkspaceId && state.workspace) {
                state.vector.ownerWorkspaceId = state.workspace.id
            }
            if (data) {
                state.canvas = data.extension;
                state.originalVector = moduleGuard.compactModule(_.cloneDeep(data));
                if (!state.canvas.triggers) {
                    Vue.set(state.canvas, 'triggers', []);
                }
            } else {
                state.canvas = null;
                state.originalVector = null;
            }
        },
        commitVectorCanvas(state, data) {
            state.vector.extension = data;
            state.canvas = data;
        },
        updateOriginal(state, data) {
            state.originalVector = moduleGuard.compactModule(_.cloneDeep(data));
        },
        commitWorkspace(state, data) {
            state.workspace = data;
            if (data != null) {
                state.client.defaults.headers['workspace'] = data.name;
                state.client.defaults.headers['wsId'] = data.id;
            } else {
                state.client.defaults.headers['workspace'] = null;
                state.client.defaults.headers['wsId'] = null;
            }

            $cookies.set('wsId', data.id);

            state.users = data.users;
            state.states = data.states;
            state.filterKeyword = null;
            authorizationStore.dispatch('setUserProfile', data.profile)
        },
        commitDiagram(state, data) {
            state.canvas.diagram = data;
        },
        /* Start Jx */
        commitUsers(state, data) {
            state.users = data;
        },
        commitList(state, data) {
            state.list = data;
        },
        /* End */
        setBaseServer(state, data) {
            state.baseServer = data;
        },
        setBeta(state, data) {
            state.beta = data;
        },
        removeState(state, targetStateId) {
            let stateToRemove = state.canvas.states
                .find(item => item.id == targetStateId);
            if (stateToRemove) {
                let ind = state.canvas.states.indexOf(stateToRemove);
                state.canvas.states.splice(ind, 1);
            }
        },
        removeFlow(state, { targetFlowId, targetActivityId }) {
            let flow = state.canvas.flows.find(flow => flow.id == targetFlowId);
            if (flow) {
                let ind = state.canvas.flows.indexOf(flow);
                state.canvas.flows.splice(ind, 1);

                let alternativeFlow = state.canvas.flows.find(
                    flow => flow.activityId == targetActivityId
                );
                //if no alternative, delete the activity
                if (!alternativeFlow) {
                    let activity = state.canvas.activities.find(
                        activity => activity.id == targetActivityId
                    );
                    if (activity) {
                        let actInd = state.canvas.activities.indexOf(activity);
                        state.canvas.activities.splice(actInd, 1);
                    }
                }
            }
        },
        removeActivity(state, targetActivityId) {
            let flows = state.canvas.flows.filter(flow => flow.activityId == targetActivityId);
            flows.forEach(flow => {
                let flowInd = state.canvas.flows.indexOf(flow);
                state.canvas.flows.splice(flowInd, 1);
            });

            let activity = state.canvas.activities.find(activity =>
                activity.id == targetActivityId);
            if (activity) {
                let ind = state.canvas.activities.indexOf(activity);
                state.canvas.activities.splice(ind, 1);
            }
        },
        removeInformation(state, targetInformationId) {
            let information = state.canvas.information.find(info => info.id == targetInformationId);
            if (information) {
                let ind = state.canvas.information.indexOf(information);
                state.canvas.information.splice(ind, 1);

                //all activity classification
                state.canvas.activities.forEach(activity => {
                    if (activity.classification) {
                        let toRemoves = activity.classification.filter(x => x.information.id == targetInformationId);
                        toRemoves.forEach(x => {
                            let cladInd = activity.classification.indexOf(x);
                            activity.classification.splice(cladInd, 1);
                        });
                    }
                });
            }
        },
        commitState(state, locusState) {
            if (!locusState.id) {
                locusState.id = commons.newUUID();
                state.canvas.states.push(locusState);
            } else {
                let originalState = state.canvas.states.find(x => x.id == locusState.id);
                originalState.color = locusState.color;
                originalState.name = locusState.name;
                originalState.description = locusState.description;
            }
        },
        commitActivity(state, { activity, flow }) {
            if (!flow && typeof originalFlow !== 'object')
                flow = {}

            //new activity, new flow
            if (!activity.id && !flow.id) {
                activity.id = commons.newUUID();
                state.canvas.activities.push(activity);

                flow.id = commons.newUUID();
                flow.activityId = activity.id;
                flow.activity = activity;
                state.canvas.flows.push(flow);
            }
            //new activity, update flow
            else if (!activity.id) {
                activity.id = commons.newUUID();
                state.canvas.activities.push(activity);

                let originalFlow = state.canvas.flows.find(x => x.id == flow.id);
                originalFlow.activityId = activity.id;
                originalFlow.activity = activity;
                originalFlow.conditional = flow.conditional;
                originalFlow.conditionalStates = flow.conditionalStates;
            }
            //new flow
            else if (!flow.id) {
                let originalActivity = state.canvas.activities.find(x => x.id == activity.id);
                originalActivity.emoji = activity.emoji;
                originalActivity.color = activity.color;

                //update classification
                originalActivity.classification = activity.classification;
                originalActivity.classification.forEach(x => {
                    // x.information = state.canvas.information.find(y => y.id == x.information.id)
                    Object.assign(x, state.canvas.information.find(y => y.id == x.id));
                });

                flow.id = commons.newUUID();
                flow.activityId = activity.id;
                flow.activity = activity;
                state.canvas.flows.push(flow);
            } else {
                let originalActivity = state.canvas.activities.find(x => x.id == activity.id);
                originalActivity.emoji = activity.emoji;
                originalActivity.color = activity.color;

                //update classification
                originalActivity.classification = activity.classification;
                originalActivity.classification.forEach(x => {
                    // x.information = state.canvas.information.find(y => y.id == x.information.id);
                    Object.assign(x, state.canvas.information.find(y => y.id == x.id));
                });

                let originalFlow = state.canvas.flows.find(x => x.id == flow.id);
                originalFlow.activityId = activity.id;
                originalFlow.activity = activity;
                originalFlow.toStateId = flow.toStateId;
                originalFlow.conditional = flow.conditional;
                originalFlow.conditionalStates = flow.conditionalStates;
            }

            //remove same activity from same state
            let toBeRemoved = state.canvas.flows.filter(x => x.id != flow.id
                && x.fromStateId == flow.fromStateId
                && x.activityId == activity.id);
            toBeRemoved.forEach(x => {
                let ind = state.canvas.flows.indexOf(x);
                state.canvas.flows.splice(ind, 1);
            });
        },
        commitInformation(state, information) {
            information.fieldName = commons.camelize(information.displayName)
            if (!information.id) {
                information.id = commons.newUUID();
                state.canvas.information.push(information);
            } else {
                let originalInformation = state.canvas.information.find(x => x.id == information.id);
                Object.assign(originalInformation, information);
            }
        },
        commitWorkDesign(state, { workDesign, activityId }) {
            let activity = state.canvas.activities.find(x => x.id == activityId);
            if (activity) {
                activity.workDesign = workDesign;
            }
        },
        commitUpdateActivity(state, { id, classification, design }) {
            let standards = ['create', 'edit', 'createEditView', 'view', 'quickView', 'createUpdate', 'delete', 'changeStatus', 'duplicate', 'comment', 'assign', 'print'];
            let activity = null;

            if (standards.indexOf(id) > -1) {
                activity = state.canvas.standardActivities.find(x => x.id == id);
            } else {
                activity = state.canvas.activities.find(x => x.id == id);
            }

            if (activity) {
                activity.design = design;
                activity.classification = classification;
            }
        },
        filterElement(state, keyword) {
            state.filterKeyword = keyword;
        },
        suggestions(state, payload) {
            state.suggestions = payload;
        },
        commitUpdateAuthorization(state, payload) {
            if (!state.canvas.authorizations)
                Vue.set(state.canvas, 'authorizations', [])

            state.canvas.authorizations = payload
        },
        // new
        setVectorTrigger(state, data) {
            let triggers = state.vector.extension.triggers;
            if (data.id) {
                const findIndex = triggers.findIndex((x) => x.id == data.id);
                if (findIndex > -1) {
                    Vue.set(triggers, findIndex, data);
                }
            } else {
                triggers.push({
                    id: commons.newUUID(),
                    ...data,
                });
            }
        },
        removeVectorTrigger(state, id) {
            let triggers = state.vector.extension.triggers;
            const findIndex = triggers.findIndex(x => x.id == id);
            if (findIndex > -1) {
                triggers.splice(findIndex, 1);
            }
        },
        registerModule(state, module) {
            state.modules[module.id] = module;
        }
    },
    getters: {
        //form design
        uploadFormData: (state) => (payload) => {
            return {
                vectorId: state.vectorId,
                fieldName: payload.fieldName,
                fieldId: payload.fieldId,
                type: payload.formType
            };
        },
        workspaceId: state => state.workspace && state.workspace.id,
        workspaceModules: state => (state.workspace && state.workspace.vectors) || [],
        workspaceStates: state => state.workspace && state.workspace.states || [],
        vectorTriggers: state => state.vector && state.vector.extension && state.vector.extension.triggers || [],
        canvasInformation: state => state.canvas && state.canvas.information || [],
        canvasMenus: state => state.canvas && state.canvas.menus || [],
        canvasDocuments: state => state.canvas && state.canvas.documents || [],
        canvasActivities: state => state.canvas && state.canvas.activities || [],
        canvasStandardActivities: state => state.canvas && state.canvas.standardActivities || [],
        canvasStates: state => state.canvas && state.canvas.states || [],
        canvasFlows: state => state.canvas && state.canvas.flows || [],
        canvasActions: state => state.canvas && state.canvas.actions || [],
        canvasLogicServices: state => state.canvas && state.canvas.logicServices || [],
        canvasImport: state => state.canvas && state.canvas.import,
    },
    actions: {
        ...commonStore.actions,
        loadCanvas(context, payload) {
            let canvas = payload.canvas
            if (canvas && canvas.information && Array.isArray(canvas.information))
                canvas.information.filter(x => x.type === 14 && !x.fields && Array.isArray(x.columns)).forEach(y => y.fields = y.columns)

            context.commit('setCanvas', canvas);
            context.commit('setBaseServer', payload.baseServer);
            context.commit('setVector', payload.vector);

            if (payload.vectorData != null) {
                context.commit('commitVector', payload.vectorData);
            }
        },
        async retrieveDashboard({ state }, payload) {
            return await state.client.get(`/api/Workspace/StudioDashboard`);
        },
        deleteState(context, payload) {
            context.commit('removeState', payload.state.id);
            let flows = context.state.canvas.flows.filter(
                flow =>
                    flow.fromStateId == payload.state.id ||
                    flow.toStateId == payload.state.id ||
                    (flow.conditionalStates &&
                        flow.conditionalStates.some(
                            condition => condition.toStateId == payload.state.id
                        ))
            );
            flows.forEach(flow =>
                context.commit('removeFlow', {
                    targetFlowId: flow.id,
                    targetActivityId: flow.activityId
                }));
        },
        deleteFlow(context, payload) {
            context.commit('removeFlow', {
                targetFlowId: payload.flowId,
                targetActivityId: payload.activityId
            });
        },
        deleteActivity(context, payload) {
            context.commit('removeActivity', payload.activity.id);
        },
        deleteInformation(context, payload) {
            context.commit('removeInformation', payload.information.id);
        },
        confirmState(context, payload) {
            context.commit('commitState', payload.state);
        },
        confirmActivity(context, payload) {
            context.commit('commitActivity', payload);
        },
        updateActivity(context, payload) {
            context.commit('commitUpdateActivity', payload);
        },
        confirmInformation(context, payload) {
            context.commit('commitInformation', payload.information);
        },
        confirmWorkDesign(context, payload) {
            context.commit('commitWorkDesign', {
                workDesign: payload.workDesign,
                activityId: payload.activityId
            })
        },
        saveDiagram(context, payload) {
            context.commit('commitDiagram', payload);
        },
        async loadVectorSelection(context, payload) {
            return await context.state.client.get(
                `${context.state.baseServer || ''}/api/m/`)
        },
        testAutomationBlock(context, payload) {
            return context.state.client.post('/api/CanvasTest/Notification', payload);
        },
        async validateAutomation(context, payload) {
            return context.state.client.post('/api/Studio/ValidateAutomation', {
                'automationBlocks': payload,
                'vectorId': context.state.vector.id
            });
        },
        testAutomation(context, payload) {
            return context.state.client.post('/api/CanvasTest/Notification', {
                'automation': payload,
                'vectorId': context.state.vectorId
            });
        },
        testDocument(context, payload) {
            return context.state.client.post('/api/CanvasTest/Document', {
                'document': payload,
                'vectorId': context.state.vector.id
            });
        },
        previewAutomation(context, payload) {
            return context.state.client.post('/api/CanvasTest/Preview', {
                'automation': payload,
                'vectorId': context.state.vectorId
            });
        },
        loadPackages(context, payload) {
            return context.state.client.post('/api/p/list', {
                "pageSize": payload.pageSize || 6,
                "category": payload.category,
                "searchText": payload.searchText,
            });
        },
        loadPackageDetail(context, payload) {
            return context.state.client.get(`/api/p/${payload}`);
        },
        loadTopics(context, payload) {
            return context.state.client.get('/api/p/topics');
        },
        packModule(context, payload) {
            payload.moduleId = context.state.vectorId.toString();
            return context.state.client.post('/api/m/package', payload);
        },
        retrieveWorkspaceInformation(context) {
            return context.state.client.get(`/api/Workspace/Update/${context.getters.workspaceId}`);
        },
        updateWorkspaceInformation(context, payload) {
            payload.update = true;
            payload.id = context.getters.workspaceId;
            return context.state.client.post('/api/Workspace', payload);
        },
        async testConfiguration(context, payload) {
            return await context.state.client.post('/api/Studio/Test', {
                'script': payload.item.script,
                'payload': payload.item.payload,
                'vectorId': context.state.vectorId,
                'logicService': true
            });
        },
        async saveVector(context, payload) {
            let vectorToSubmit = _.cloneDeep(context.state.vector);

            const lists = ['actions', 'documents', 'flows', 'logicServices',
                'menus', 'notifications', 'states', 'triggers',
                'authorizations'];

            const informationList = ['connectionField', 'connectionId',
                'description', 'extra', 'displayKey', 'uniqueKey'];

            const toRemoveList = ['connectionModel', 'connectionFieldModel']

            if (vectorToSubmit.extension['information']) {
                vectorToSubmit.extension['information'].forEach(row => {
                    informationList.forEach(field => {
                        if (row[field] == null || row[field] == false) {
                            delete row[field];
                        }
                    });

                    toRemoveList.forEach(field => {
                        delete row[field];
                    });

                    if (row.fields) {
                        row.fields.forEach(tableField => {
                            informationList.forEach(columnField => {
                                if (tableField[columnField] == null || tableField[columnField] == false) {
                                    delete tableField[columnField];
                                }
                            });

                            toRemoveList.forEach(field => {
                                delete tableField[field];
                            });
                        });
                    }

                    delete row['columns'];
                });
            }

            lists.forEach(fieldList => {
                if (vectorToSubmit.extension[fieldList] == null
                    || vectorToSubmit.extension[fieldList].length == 0) {
                    delete vectorToSubmit.extension[fieldList];
                }
            });

            vectorToSubmit.dynamic.expansion = JSON.stringify(vectorToSubmit.extension);
            //delete vectorToSubmit.extension;

            vectorToSubmit.entityHandler = {
                manyToManyCollectionsToSave: ['Workspaces']
            };

            let result = await context.state.client.post('/api/Studio', {
                vector: vectorToSubmit
            });

            context.state.vector.audit.updatedDate = result.data.updatedDate;
            context.state.vector.id = result.data.id;
            context.commit('commitVector', context.state.vector);
            // context.commit('updateOrignal', vectorToSubmit);
            return result;
        },
        async loadVector(context, payload) {
            let vm = this;
            let result = await context.state.client.get(`/api/Studio/${payload}`);
            if (result.data.extension.standardActivities == null) {
                result.data.extension.standardActivities = commons.standards;
            } else {
                let standardActivities = result.data.extension.standardActivities;
                Vue.set(result.data.extension, 'standardActivities', []);
                commons.standards.forEach(standard => {
                    let found = standardActivities.find(x => x.id == standard.id);
                    if (found) {
                        standardActivities = standardActivities.filter(item => item !== found);
                        result.data.extension.standardActivities.push(found);
                    } else {
                        result.data.extension.standardActivities.push(standard);
                    }
                });

                standardActivities.forEach(x => {
                    if (result.data.extension.triggers
                        && result.data.extension.triggers.find(y => y.item == x.id)) {
                        result.data.extension.standardActivities.push(x);
                    }
                });
            }

            context.commit('commitVector', result.data)

            if (result.data.ownerWorkspaceId && (!context.state.workspace || context.state.workspace.id != result.data.ownerWorkspaceId)) {
                let workspaceResult = await context.state.client.get(`/api/Workspace/${result.data.ownerWorkspaceId}?studio=studio`);
                authorizationStore.dispatch('setRoles', workspaceResult.data.roles);
                context.commit('setBeta',
                    (authorizationStore.state.roles || []).some(x => x === 'Administrator' || x === 'Consultant'));
                commons.expandMenu(workspaceResult.data.menus, workspaceResult.data.vectors, true);
                context.commit('commitWorkspace', workspaceResult.data);
            }

            commons.setChildMenu(context.state.workspace.menus, context.state.vector);
        },
        async installPackage({ state }, payload) {
            return await state.client.post(`/api/p/install`, payload);
        },
        async findVariable(context, payload) {
            if (payload.moduleId.toString() == context.state.vector.id.toString()) {
                let vector = _.cloneDeep(context.state.vector);
                vector.extension.standardActivities.forEach(standard => {
                    if (standard.design) {
                        commons.expandWorkDesign(vector.extension.information, standard.design);
                        standard.classification = commons.getAllElements(null, standard.design);
                    }
                });

                vector.extension.activities.forEach(activity => {
                    if (activity.design) {
                        commons.expandWorkDesign(vector.extension.information, activity.design);
                        activity.classification = commons.getAllElements(null, activity.design);
                    }
                });

                return {
                    id: vector.id,
                    emoji: vector.emoji,
                    name: vector.name,
                    standards: vector.extension.standardActivities,
                    activities: vector.extension.activities,
                    information: vector.extension.information
                }
            }

            if (!context.state.modules[payload.moduleId]) {
                let result = await context.state.client.get(`/api/m/${payload.moduleId}`);
                context.commit('registerModule', result.data);
            }

            return context.state.modules[payload.moduleId];
        },
        // Start Jx
        setUsers(context, payload) {
            let users = payload.map((x) => (
                Object.assign(x, {
                    username: x.username || x.userName
                })
            ))

            context.commit('commitUsers', users)
        },
        loadList(context, payload) {
            if (context.state.workspace && context.state.workspace.menus && context.state.workspace.menus.length) {
                let result = _.findDeep(context.state.workspace.menus, x => (x.id === payload), {
                    childrenPath: 'children'
                })
                if (result && result.value && result.parent && result.parent.id && result.parent.type != 'group') {
                    context.commit('commitList', {
                        id: result.value.id,
                        name: result.value.name,
                        emoji: result.value.emoji,
                        parentId: result.parent.id,
                    })
                    return
                }
            }

            context.commit('commitList', null)
        },
        async addVector({ state, dispatch, commit }, payload) {
            try {
                state.vector = {
                    name: payload.name,
                    emoji: payload.emoji,
                    description: payload.description,
                    ownerWorkspaceId: state.workspace.id,
                    extension: {
                        standardActivities: commons.standards
                    },
                    dynamic: {},
                    audit: {}
                }
                const res = await dispatch('saveVector');
                await dispatch('loadVector', res.data.id);
                dispatch('updateWorkspaceMenus');
            } catch (err) {
                throw err;
            }
        },
        async deleteVector(context, payload) {
            try {
                /* reconstruct menus */
                let workspace = _.cloneDeep(context.state.workspace)
                function deleteMenu(menus, id) {
                    let menu = menus.find(x => x.id == id);
                    if (menu) {
                        menus.splice(menus.indexOf(menu), 1);
                    } else {
                        let menuDeep = _.findDeep(menus, x => (x.id == id), { childrenPath: 'children' })
                        if (menuDeep && menuDeep.value && menuDeep.parent && Array.isArray(menuDeep.parent.children)) {
                            menuDeep.parent.children.splice(menuDeep.parent.children.indexOf(menuDeep.value), 1);

                            if (menuDeep.parent.type == 'group' && menuDeep.parent.children.length === 0)
                                deleteMenu(menus, menuDeep.parent.id);
                        }
                    }
                }
                deleteMenu(workspace.menus, payload);
                /* remove vector */
                workspace.vectors = workspace.vectors.filter(x => x.id != payload);
                /* commit workspace */
                context.commit('commitWorkspace', workspace);
                /* save workspace */
                await context.dispatch('saveWorkspace');
                /* delete vector */
                await context.state.client.post('/api/Studio/delete/', {
                    id: payload,
                });
                /* load workspace */
                await context.dispatch('loadWorkspace', {
                    id: context.getters.workspaceId,
                });
                /* reset vector */
                context.dispatch('resetVector');
            } catch (err) {
                throw err;
            }
        },
        // End
        resetVector(context, payload) {
            context.commit('commitVector', null)
        },
        async loadWorkspace({ state, commit, dispatch }, payload) {
            let workspaceId = payload.id;
            if (!workspaceId) {
                try {
                    let res = await dispatch('searchWorkspace', { search: '' });
                    if (Array.isArray(res) && res[0].id)
                        workspaceId = res[0].id;
                    else
                        throw "unable retrieve workspaces"
                } catch (err) {
                    throw err;
                }
            }
            try {
                let res = await state.client.get(`/api/Workspace/${workspaceId}?studio=studio`);
                authorizationStore.dispatch('setRoles', res.data.roles);
                commit('commitWorkspace', res.data);
                commons.expandMenu(res.data.menus, res.data.vectors);
                commit('setBeta',
                    (authorizationStore.state.roles || []).some(x => x === 'Administrator' || x === 'Consultant'));
                return res.data;
            } catch (err) {
                throw err;
            }
        },
        async selectWorkspace(context, payload) {
            let workspaceResult = await context.state.client.get(`/api/Workspace/${payload.id}?studio=studio`);
            authorizationStore.dispatch('setRoles', workspaceResult.data.roles);
            commons.expandMenu(workspaceResult.data.menus, workspaceResult.data.vectors);
            context.commit('commitWorkspace', workspaceResult.data);
            context.commit('setBeta',
                (authorizationStore.state.roles || []).some(x => x === 'Administrator' || x === 'Consultant'));
            if (context.state.vector)
                commons.setChildMenu(context.state.workspace.menus, context.state.vector);
        },
        async searchWorkspace(context, payload) {
            let result = await context.state.client.get(`/api/Workspace?search=${payload.search}&studio=studio`);
            return result.data;
        },
        async searchRecipient(context, payload) {
            let result = await context.state.client.get(`/api/studio/Recipient?search=${payload.search}`);
            return result;
        },
        async filterElement(context, payload) {
            context.commit('filterElement', payload);
            let keyword = payload;
            if (keyword) {
                let lowerKeyword = keyword.toLowerCase();
                //if nothing, call AI
                let hasEntry = context.state.canvas.information.some(x => x.displayName.toLowerCase() == lowerKeyword)
                    || context.state.canvas.activities.some(x => x.name.toLowerCase() == lowerKeyword)
                    || context.state.canvas.standardActivities.some(x => x.name.toLowerCase() == lowerKeyword)
                    || context.state.canvas.documents.some(x => x.name.toLowerCase() == lowerKeyword)
                    || context.state.canvas.states.some(x => x.name.toLowerCase() == lowerKeyword);

                if (!hasEntry) {
                    let result = await context.state.client.get(`/api/ai?type=suggest&text=${encodeURIComponent(lowerKeyword)}`);
                    console.log(result.data);
                    let suggestions = [
                        ...result.data.user,
                        ...(result.data.suggest != null ? result.data.suggest : [])
                    ];

                    suggestions = suggestions.map(item => {
                        if (item['activity'] != null) {
                            return {
                                section: 'activity',
                                name: item.activity.name
                            }
                        } else if (item['state'] != null) {
                            return {
                                section: 'state',
                                name: item.state.name,
                                color: item.state.color
                            }
                        } else {
                            return {
                                section: 'information',
                                displayName: item.information.displayName,
                                type: item.information.type
                            }
                        }
                    });

                    suggestions = suggestions.slice(0, 5);

                    context.commit('suggestions', suggestions);

                } else {
                    context.commit('suggestions', []);
                }
            } else {
                context.commit('suggestions', []);
            }
        },
        async retrieveAuthorizationEntities(context, payload) {
            let result = await context.state.client.post(`/api/Studio/AuthorizationSelection`, payload);
            return result;
        },
        async saveWorkspace(context, payload) {
            if (context.state.workspace) {
                let menus = _.cloneDeep(context.state.workspace.menus);
                menus = commons.trimMenu(menus);
                console.log(menus);
                let result = await context.state.client.post(`/api/Workspace`, {
                    id: context.state.workspace.id,
                    menus,
                    lastUpdatedOn: context.state.workspace.lastUpdatedOn
                });
                return result;
            }
        },
        async createWorkspace(context, payload) {
            let result = await context.state.client.post(`/api/Workspace`, payload);
            return result;
        },
        async loadNotifcationDashboard(context, payload) {
            let result = await context.state.client.get(`/api/studio/NotificationDashboard/${context.state.vector.id}`);
            return result;
        },
        async ai(context, payload) {
            let result = await context.state.client.get(`/api/ai?type=${payload.type}&text=${payload.text}`);
            return result;
        },
        async retrieveSerialNumber(context, payload) {
            let result = await context.state.client.get(`/api/studio/serialNumber/${context.state.vector.id}`);
            return result;
        },
        async saveSerialNumber(context, payload) {
            try {
                payload.moduleId = context.state.vector.id;
                let result = await context.state.client.post(`/api/studio/serialNumber`, payload);
                return result;
            } catch (err) {
                throw err;
            }
        },
        async loadInformation(context, payload) {
            let result = await context.state.client.get(`/api/studio/information?id=${payload.name}`);
            return result;
        },
        async loadClassification(context, payload) {
            let result = await context.state.client.post(`/api/studio/classification`, payload);
            return result;
        },
        updateAuthorization(context, payload) {
            context.commit('commitUpdateAuthorization', payload);
        },
        // new
        setVectorTrigger({ commit }, data) {
            commit('setVectorTrigger', data)
        },
        removeVectorTrigger({ commit }, id) {
            commit('removeVectorTrigger', id)
        },
        updateWorkspaceMenus({ state, commit }) {
            let workspace = _.cloneDeep(state.workspace);
            workspace.menus.push({
                id: state.vector.id,
                emoji: state.vector.emoji,
                name: state.vector.name,
                children: [],
                module: state.vector.id,
                ownerWorkspaceId: workspace.id,
                currentWorkspace: true,
                published: true,
            });
            workspace.vectors.push({
                id: state.vector.id,
                emoji: state.vector.emoji,
                name: state.vector.name,
                menus: [],
            });
            commit('commitWorkspace', workspace);
        },
        updateVectorCanvas({ commit }, data) {
            commit("commitVectorCanvas", data);
        },
        async loadModuleInformation({ state }, payload) {
            try {
                const res = await state.client.get(`/api/m/${payload}`);
                return res.data.information;
            } catch (err) {
                throw err;
            }
        },
    }
});